import { AxiosInstance } from "axios"
import { Instruction } from "./instructionTypes"

export enum SupportInstructionsQuery {
    INSTRUCTIONS_FOR_MERCHANT = "instructions-for-merchant",
    INSTRUCTIONS_FOR_SUPPLIER = "instructions-for-supplier",
    INSTRUCTIONS_FOR_COMPANY = "instructions-for-company",
}

export type InstructionsResponse = Readonly<{
    instructions: Array<Instruction>
}>

export async function fetchMerchantInstructions(
    { merchantId }: { merchantId: number },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<InstructionsResponse> {
    const url = `/support/merchants/${merchantId}/instructions`

    const { data } = await axios.get(url, {
        signal,
    })

    return data
}

export async function fetchSupplierInstructions(
    { supplierId }: { supplierId: number },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<InstructionsResponse> {
    const url = `/support/suppliers/${supplierId}/instructions`

    const { data } = await axios.get(url, {
        signal,
    })

    return data
}

export async function fetchCompanyInstructions(
    { companyId }: { companyId: number },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<InstructionsResponse> {
    const url = `/support/companies/${companyId}/instructions`

    const { data } = await axios.get(url, {
        signal,
    })

    return data
}

export enum UserTypeURL {
    SUPPLIER = "suppliers",
    MERCHANT = "merchants",
    COMPANY = "companies",
    DEFAULT = "",
}

export async function fetchInstructionsByRole(
    { userId, role }: { userId: number; role: UserTypeURL },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<InstructionsResponse> {
    const url = `/support/${role}/${userId}/instructions`

    const { data } = await axios.get(url, {
        signal,
    })

    return data
}
